
// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { mergeHeadWithStorage } from '../../../utils/gridHeadStorage';

export default class ChainsPage extends GridPageAbstract {
    constructor(props) {
        super(props);
        this.Name = 'chains';
        this.Server = this.props.context.getState().server.chains;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name'];
        this.showDatePicker = false;

        const defaultHead = [
            { id: 'name', label: 'name', alignRight: false, cell: 'Text', displayGrid: true },
        ];
        this.Head = mergeHeadWithStorage(this.Name, defaultHead);

        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}

